import api from './api';

const unwrap = async (request) => {
  const { data } = await request();
  return data;
};

export const listCommerceEntity = (entity) => unwrap(() => api.get(`/commerce/${entity}`));

export const saveCommerceEntity = (entity, payload) => {
  const request = payload?.id
    ? () => api.put(`/commerce/${entity}/${payload.id}`, payload)
    : () => api.post(`/commerce/${entity}`, payload);
  return unwrap(request);
};

export const updateCommerceEntity = (entity, id, payload) => unwrap(() => api.put(`/commerce/${entity}/${id}`, payload));
export const deleteCommerceEntity = (entity, id) => unwrap(() => api.delete(`/commerce/${entity}/${id}`));
export const saveDeliveryZoneMembers = (id, payload) => unwrap(() => api.put(`/commerce/deliveryZones/${id}/members`, payload));
export const saveDeliveryPolicyTiers = (id, tiers) => unwrap(() => api.put(`/commerce/deliveryPolicies/${id}/tiers`, { tiers }));
export const saveSlotCalendar = (id, payload) => unwrap(() => api.put(`/commerce/slotProfiles/${id}/calendar`, payload));
export const saveCustomerSegmentMembers = (id, members) => unwrap(() => api.put(`/commerce/customerSegments/${id}/members`, { members }));
export const saveCouponTargets = (id, payload) => unwrap(() => api.put(`/commerce/coupons/${id}/targets`, payload));
